// extracted by mini-css-extract-plugin
export default {"nav-list-item":"src-assets-style-scss-___primary-navigation__nav-list-item___cX-ph","cb-multi":"src-assets-style-scss-___primary-navigation__cb-multi___cetKp"};